import React, { Component } from "react";
import WallMenu from "./WallMenu";
import SummaryByCountry from "../components/SummaryByCountry";

class WallLeft extends Component {
  render() {
    return (
      <React.Fragment>
        <WallMenu />
        <SummaryByCountry />
      </React.Fragment>
    );
  }
}

export default WallLeft;
